var modules_f92dd299 = {"container":"Popover_module_container__88513de2","trigger-backdrop":"Popover_module_triggerBackdrop__88513de2","overlay":"Popover_module_overlay__88513de2","backdrop":"Popover_module_backdrop__88513de2","header":"Popover_module_header__88513de2","content":"Popover_module_content__88513de2","close":"Popover_module_close__88513de2"};
import "../../../assets/esm/components/Popover/src/Popover~B5Xw5lZJ.css";

export { modules_f92dd299 as default };
//# sourceMappingURL=Popover.module.less.js.map
